export default __webpack_public_path__ + "static/media/card-bogota-active.da3a40f7.png";